import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import AdminService from '../../services/admin.service';

const ActivityLogsList = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        loadLogs();
    }, []);
    
    const loadLogs = async () => {
        try {
            setLoading(true);
            const response = await AdminService.getActivityLogs();
            // Limita a 20 eventi
            setLogs(response.data.slice(0, 20));
        } catch (error) {
            setError('Errore nel caricamento dei log');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    
    if (loading) return <div>Caricamento logs...</div>;
    if (error) return <div className="text-red-500">{error}</div>;
    
    return (
        <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold flex items-center">
                    <Bell className="w-5 h-5 mr-2 text-blue-600" />
                    Attività Recenti (ultimi 20)
                </h2>
            </div>
            <div className="space-y-4">
                {logs.map((log) => (
                    <div key={log.id} className="border-b last:border-0 pb-3 last:pb-0">
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="font-medium">{log.description}</p>
                                <p className="text-sm text-gray-600">{log.type}</p>
                                <p className="text-xs text-gray-500">{log.user_type}</p>
                            </div>
                            <div className="text-right">
                                <p className="text-sm font-medium text-blue-600">
                                    {log.status || 'Completato'} 
                                </p>
                                <p className="text-xs text-gray-500">
                                    {new Date(log.created_at).toLocaleString()}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ActivityLogsList;